import React from 'react';
import { Box } from 'rebass/styled-components';
import {
  Heading, Section, Stepper, Subtitle, Link, NavigationLink, FeatureGate,
} from '../components';
import { Analytics } from '../sections';
import { useAppState, useNotification } from '../hooks';

const LINK_TO_DOCS = 'https://developers.liveperson.com/maven-askmaven-overview.html';

function AskMaven() {
  const { accountId: brandId } = useAppState();
  const { addNotification } = useNotification();

  return (
    <Box>
      <Heading>APIs</Heading>
      <Subtitle mb={3}>
        AskMaven is a REST interface that allows you to call Orchestrator policies from
        a bot or LOB to get the next best action (route to bot, human, or skill).
      </Subtitle>
      <Section
        section="askmaven-getting-started"
        title="Getting started"
        subtitle={(
          <Box>
            Using the AskMaven APIs with your bot requires configuring several different features in
            the Conversational AI suite. To complete the remaining steps, please see the
            {' '}
            <Link href={LINK_TO_DOCS} target="_blank" rel="noopener noreferrer">
              documentation
            </Link>
            .
          </Box>
)}
      >
        <Stepper
          steps={[
            {
              id: 1,
              title: <NavigationLink to="/intent-content-policies">Build routing policies</NavigationLink>,
            },
            { id: 2, title: 'Use AskMaven API from a bot or LOB' },
            { id: 3, title: 'Start using policies' },
          ]}
          activeStep={2}
        />
      </Section>
      <FeatureGate feature="maven.feature.analytics">
        <Analytics
          title="AskMaven API Usage"
          subtitle="The following shows the number of times the AskMaven API was called"
          addNotification={addNotification}
          brandId={brandId}
          type="askMavenAPI"
          onlyShowTotal
        />
      </FeatureGate>
    </Box>
  );
}

export default AskMaven;
